"use strict";

exports.__esModule = true;
exports.default = void 0;
// A (possibly faster) way to get the current timestamp as an integer.
var _default = exports.default = Date.now || function () {
  return new Date().getTime();
};